import cn from '@sindresorhus/class-names';
import React from 'react';

import styles from './RatingStars.module.scss';
import {StarIcon} from './StarIcon/StarIcon';

const STARS_COUNT = 5;
const STARS_ITERATIONS_ARRAY = Array.from(Array(STARS_COUNT), (_, i) => i + 1);

export enum STARS_COLORS {
  PRIMARY = '#FFA000',
  SECONDARY_APP_CARD = '#99A2AD',
  SECONDARY_APP_SCREEN = '#6D7885',
}

type Props = {
  rating?: number;
  color: STARS_COLORS;
  className?: string;
};

export const RatingStars = ({rating = 0, className, color}: Props) => {
  return (
    <span className={cn(className, styles.layout)} aria-hidden="true">
      {STARS_ITERATIONS_ARRAY.map((starNumber) => {
        const offsetValue = 1 - (starNumber - rating);

        return (
          <span
            className={styles.starWrapper}
            key={'starRatingStar #' + starNumber}
          >
            <StarIcon offset={offsetValue} color={color} />
          </span>
        );
      })}
    </span>
  );
};
